import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const DiamondFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function DiamondFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path d="M7.817 1.75 1.739 7.807c-2.319 2.309-2.319 6.067 0 8.386l6.078 6.057a5.919 5.919 0 0 0 8.366 0l6.078-6.057c2.319-2.309 2.319-6.067 0-8.386L16.183 1.75a5.919 5.919 0 0 0-8.366 0Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default DiamondFilled;